import Vue from "vue";
import VueI18n from "vue-i18n";
import { getUserLocales } from "get-user-locale";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "hu",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: loadLocaleMessages()
});

let userPreferredLocale = null;
const userLocales = getUserLocales();
if (userLocales.includes("hu")) userPreferredLocale = "hu";
else
  userPreferredLocale = userLocales.find(l =>
    i18n.availableLocales.includes(l)
  );

i18n.locale =
  window.localStorage.getItem("lang") || userPreferredLocale || i18n.locale;
window.document.title = i18n.t("app-title");

export default i18n;
